import { render, staticRenderFns } from "./CRUDUsuarios.vue?vue&type=template&id=60437bf3&"
import script from "./CRUDUsuarios.vue?vue&type=script&lang=js&"
export * from "./CRUDUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports